import { useSortable } from '@dnd-kit/sortable';
import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { IconGripVertical } from '@tabler/icons-react';
import LinkBlockDragAndEdit from './LinkBlockDragAndEdit';
import ImageBlockDragAndEdit from './ImageBlockDragAndEdit';
import YoutubeDragBlock from './YoutubeDragBlock';
import CarouselDragBlock from './CarouselDragBlock';
import GridDragBlock from './GridDragBlock';

const BlocksList = React.memo(({ blockData, callback }) => {
    const { attributes, listeners, setNodeRef, transform, transition, } = useSortable({ id: blockData?._id });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
    };

    return (
        <div ref={setNodeRef} style={style}>
            <div className='p-3 mb-2 rounded-lg border-2 border-primary bg-white flex gap-2 items-start'>
                {blockData?.blockType == 1 && <LinkBlockDragAndEdit data={blockData} callback={() => callback()} dragButton={<button className='cursor-move' {...attributes} {...listeners}> <IconGripVertical /> </button>} />}
                {blockData?.blockType == 2 && <ImageBlockDragAndEdit data={blockData} callback={() => callback()} dragButton={<button className='cursor-move' {...attributes} {...listeners}> <IconGripVertical /> </button>} />}
                {blockData?.blockType == 3 && <YoutubeDragBlock data={blockData} callback={() => callback()} dragButton={<button className='cursor-move' {...attributes} {...listeners}> <IconGripVertical /> </button>} />}
                {blockData?.blockType == 4 && <CarouselDragBlock data={blockData} callback={() => callback()} dragButton={<button className='cursor-move' {...attributes} {...listeners}> <IconGripVertical /> </button>} />}
                {blockData?.blockType == 5 && <GridDragBlock data={blockData} callback={() => callback()} dragButton={<button className='cursor-move' {...attributes} {...listeners}> <IconGripVertical /> </button>} />}
            </div>
        </div>
    )
})

export default BlocksList